export default "__VITE_ASSET__jBnl6qT8__"